import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";

export interface ChecklistOption {
  id: number;
  name: string;
}

export interface ChecklistOptions {
  checklists: ChecklistOption[];
  default_issueset_id: number | null;
  recent_issueset_ids: number[];
}

export default function fetchChecklistOptions(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CHECKLIST_OPTIONS_FETCH,
    (organisationId: number, projectId: number) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            "/checklist-options",
          {withCredentials: true},
        )
        .then((response: {data: ChecklistOptions}) => response.data),
  );
}
